function createEmptyRedCapDraft() {
    return {
        payload: {
            patient_id: null,
            redcap_event_name: "",
            redcap_repeat_instance: "",
            first_name: "",
            middle_name: "",
            last_name: "",
            dob: "",
            street_address: "",
            city: "",
            state: "",
            zip: "",
            phone: "",
            sex: "",
            race: "",
            highest_education_level: "",

            test_date: "",

            think_hearing_loss: "",
            onset_speed___1: "",
            onset_speed___2: "",
            onset_speed___3: "",
            onset_speed___4: "",
            onset_speed___5: "",

            had_hearing_tested: "",
            when_last_test: "",
            why_no_test___1: "",
            why_no_test___2: "",
            why_no_test___3: "",
            why_no_test___4: "",
            why_no_test___5: "",

            think_diagnosed_hearing_loss: "",
            think_hearing_loss_in: "",
            diagnosed_hearing_loss_in: "",

            any_diagnoses___1: "",
            any_diagnoses___2: "",
            any_diagnoses___3: "",
            any_diagnoses___4: "",
            any_diagnoses___5: "",
            any_diagnoses___6: "",

            balance_issues: "",
            balance_symptoms___1: "",
            balance_symptoms___2: "",
            balance_symptoms___3: "",
            balance_symptoms___4: "",
            balance_symptoms___5: "",

            hearing_loss_changed: "",
            exposed_to_loud_noises: "",
            type_of_loud_noise: "",
            duration_of_noise_exposure: "",
            has_ear_pain: "",
            had_ear_surgery___1: "",
            had_ear_surgery___2: "",
            had_ear_surgery___3: "",
            has_had_tinnitus: "",
            which_ear_tinnitus___1: "",
            which_ear_tinnitus___2: "",
            which_ear_tinnitus___3: "",
            which_ear_tinnitus___4: "",
            bothersome_tinnitus_left: "",
            bothersome_tinnitus_right: "",
            tinnitus_heartbeat: "",
            questionnaire_complete: "",

            hz_500_passed_right: "",
            hz_500_passed_left: "",
            hz_1000_passed_right: "",
            hz_1000_passed_left: "",
            hz_2000_passed_right: "",
            hz_2000_passed_left: "",
            hz_4000_passed_right: "",
            hz_4000_passed_left: "",
            hz_6000_passed_right: "",
            hz_6000_passed_left: "",
            right_ear_passed: "",
            left_ear_passed: "",
            screening_complete: "",

            right_threshold_500: "",
            left_threshold_500: "",
            right_threshold_1000: "",
            left_threshold_1000: "",
            right_threshold_2000: "",
            left_threshold_2000: "",
            right_threshold_4000: "",
            left_threshold_4000: "",
            right_threshold_6000: "",
            left_threshold_6000: "",
            right_threshold_8000: "",
            left_threshold_8000: "",
            diagnostic_complete: "",

            received_referral: "",
            referral_type___1: "",
            referral_type___2: "",
            referral_type___3: "",
            referral_type___4: "",
            referral_type___5: "",
            reasons_ent: "",
            reasons_audiologist: "",
            reasons_tinnitusrecs: "",
            reasons_psychologist: "",
            reasons_hearingaids: "",
        }
    };
}

export function mapPatientToRedcapPayload(patientDraft) {
    const { payload } = createEmptyRedCapDraft();

    const d = patientDraft?.demographics ?? {};
    payload.patient_id = 'new';
    payload.redcap_event_name = 'enrollment_arm_1';
    payload.first_name = d.first_name ?? "";
    payload.middle_name = d.middle_name ?? "";
    payload.last_name = d.last_name ?? "";
    payload.dob = d.dob ?? "";
    payload.street_address = d.street_address ?? "";
    payload.city = d.city ?? "";
    payload.state = d.state ?? "";
    payload.zip = d.zip ?? "";
    payload.phone = d.phone ?? "";
    payload.sex = d.sex ?? "";
    payload.race = d.race ?? "";
    payload.highest_education_level = d.highest_education_level ?? "";


    return payload;
}

export function mapResultsToRedcapPayload(patientDraft, patientId = null) {
    const { payload } = createEmptyRedCapDraft();


    const t = patientDraft?.test ?? {};


    payload.patient_id = patientId;
    payload.redcap_event_name = (patientDraft.test.testType === "Screening Test") ? 'screening_visit_arm_1' : 'diagnostic_visit_arm_1';

    payload.redcap_repeat_instance = 'new';
    payload.test_date = t.testDate ?? "";

    Object.assign(payload, t.results ?? {});

    return payload;
}

